import React from "react";
import { browserHistory } from "react-router";
import Storage from "../base/Storage";

export const logOut = function () {
    localStorage.clear();
    //eslint-disable-next-line
    location.reload();
};

export const setUser = function (user) {
    Storage.set("user", user);
};

export const getUser = function () {
    return Storage.get("user");
};

export const isLoggedIn = function () {
    return typeof Storage.get("atoken") !== "undefined" && Storage.get("atoken") !== null && getUser() !== null && typeof getUser().role !== "undefined";
};

export const inArray = function (array, value) {
    return array.indexOf(value) !== -1;
}

export const hasPermission = function (permission, test = false) {

    const ac = Storage.get("allowed_components");
    let has = ac.indexOf(permission) !== -1;

    if (!test) {
        return has;
    }

    const role = getUser().role;

    switch (test.status_val) {
        case "in_progress": // Rozpracovaný

            switch (permission) {
                case "TestEdit":
                    has = has && inArray([4, 5, 6, 7], role);
                    break;
                case "TestStatusChange":
                    has = has && inArray([4, 5, 6, 7], role);
                    break;
                case "ErrorResultNew":
                    has = has && inArray([4, 5, 6, 7], role);
                    break;
                case "ErrorResultEdit":
                    has = has && inArray([4, 5, 6, 7], role);
                    break;
                case "ErrorResultDelete":
                    has = has && inArray([4, 5, 6, 7], role);
                    break;
                case "TestFileUpload":
                    has = has && inArray([4, 5, 6, 7], role);
                    break;
                case "TestFileDelete":
                    has = has && inArray([4, 5, 6, 7], role);
                    break;
                case "FormFill":
                    has = has && inArray([4, 5, 6, 7], role);
                    break;
                default:
                    has = false;
            }

            break;
        case "verified": // Kontrolovaný

            switch (permission) {
                case "TestEdit":
                    has = has && inArray([5, 6, 7], role);
                    break;
                case "TestStatusChange":
                    has = has && inArray([5, 6, 7], role);
                    break;
                case "ErrorResultNew":
                    has = has && inArray([5, 6, 7], role);
                    break;
                case "ErrorResultEdit":
                    has = has && inArray([5, 6, 7], role);
                    break;
                case "ErrorResultDelete":
                    has = has && inArray([5, 6, 7], role);
                    break;
                case "TestFileUpload":
                    has = has && inArray([5, 6, 7], role);
                    break;
                case "TestFileDelete":
                    has = has && inArray([5, 6, 7], role);
                    break;
                case "FormFill":
                    has = has && inArray([5, 6, 7], role);
                    break;
                default:
                    has = false;
            }

            break;
        case "closed": // Ukončený

            switch (permission) {
                case "TestEdit":
                    has = has && inArray([], role);
                    break;
                case "TestStatusChange":
                    has = has && inArray([3, 7], role);
                    break;
                case "ErrorResultNew":
                    has = has && inArray([], role);
                    break;
                case "ErrorResultEdit":
                    has = has && inArray([3], role);
                    break;
                case "ErrorResultDelete":
                    has = has && inArray([], role);
                    break;
                case "TestFileUpload":
                    has = has && inArray([], role);
                    break;
                case "TestFileDelete":
                    has = has && inArray([], role);
                    break;
                case "FormFill":
                    has = has && inArray([3], role);
                    break;
                default:
                    has = false;
            }

            break;
        case "done": // Vykonaný

            switch (permission) {
                case "TestEdit":
                    has = has && inArray([], role);
                    break;
                case "TestStatusChange":
                    has = has && inArray([7], role);
                    break;
                case "ErrorResultNew":
                    has = has && inArray([], role);
                    break;
                case "ErrorResultEdit":
                    has = has && inArray([], role);
                    break;
                case "ErrorResultDelete":
                    has = has && inArray([], role);
                    break;
                case "TestFileUpload":
                    has = has && inArray([], role);
                    break;
                case "TestFileDelete":
                    has = has && inArray([], role);
                    break;
                case "FormFill":
                    has = has && inArray([], role);
                    break;
                default:
                    has = false;
            }

            break;
        case "archived": // Archivovaný
            switch (permission) {
                case "TestEdit":
                    has = has && inArray([], role);
                    break;
                case "TestStatusChange":
                    has = has && inArray([7], role);
                    break;
                case "ErrorResultNew":
                    has = has && inArray([], role);
                    break;
                case "ErrorResultEdit":
                    has = has && inArray([], role);
                    break;
                case "ErrorResultDelete":
                    has = has && inArray([], role);
                    break;
                case "TestFileUpload":
                    has = has && inArray([], role);
                    break;
                case "TestFileDelete":
                    has = has && inArray([], role);
                    break;
                case "FormFill":
                    has = has && inArray([], role);
                    break;
                default:
                    has = false;
            }
            break;
        default:
            break;
    }


    return has;
}

export default class Auth extends React.Component {
    constructor(props) {
        super(props);
        if (typeof props.route !== "undefined") {
            
            if (props.route.roles.indexOf(getUser().role) === -1) {
                browserHistory.push("/");
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/auth/Auth.js